import React from 'react';
import RoomTable from '@/page/customer/RoomPage/RoomTable';

// 可以作为组件在继承中使用
export default function TransferPageRoomPage() {
    return (
        <div style={{overflowY: 'auto'}}>
            <RoomTable roomKeys={[]} />
        </div>
    );
}
